/*
  Routine8 v2 — shared behaviour.
  Scroll reveal for .r8-reveal and active-phase tracking for [data-r8-phases].
  Re-runs on Shopify theme-editor section loads.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealIn(root) {
    var items = (root || document).querySelectorAll('.r8-reveal:not(.is-in)');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    // Was beim Start schon im Fenster steht, bleibt stehen: erst is-in setzen,
    // dann html.r8-js - beides im selben Frame, also ohne Ausblenden und ohne
    // Uebergang. Nur der Rest wartet auf den Observer.
    var vh = window.innerHeight;
    var rest = [];
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-in');
      else rest.push(el);
    });
    document.documentElement.classList.add('r8-js');
    items = rest;
    if (!items.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  // Sticky phase sections: mark the phase currently in view so the paired
  // media can cross-fade to it.
  function phasesIn(root) {
    var groups = (root || document).querySelectorAll('[data-r8-phases]');

    groups.forEach(function (group) {
      if (group.dataset.r8PhasesReady === 'true') return;
      group.dataset.r8PhasesReady = 'true';

      var steps = group.querySelectorAll('[data-r8-phase]');
      var medias = group.querySelectorAll('[data-r8-phase-media]');
      if (!steps.length) return;

      function activate(key) {
        steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.r8Phase === key); });
        medias.forEach(function (m) { m.classList.toggle('is-active', m.dataset.r8PhaseMedia === key); });
      }

      activate(steps[0].dataset.r8Phase);

      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate(entry.target.dataset.r8Phase);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      steps.forEach(function (s) { io.observe(s); });
    });
  }

  // The hero sizes itself to the viewport minus the sticky header. That
  // height changes with the announcement bar, the breakpoint and the theme
  // editor, so measure it instead of hard-coding a guess.
  function chromeHeight() {
    // Everything above the first v2 section: announcement bar plus header.
    // Measuring the section's own document offset covers both, whatever the
    // merchant has switched on.
    var first = document.querySelector('.r8-hero');
    var h;

    if (first) {
      h = Math.round(first.getBoundingClientRect().top + window.scrollY);
    } else {
      var header = document.querySelector('.header-wrapper, sticky-header');
      if (!header) return;
      h = Math.round(header.getBoundingClientRect().height);
    }

    if (h > 0 && h < window.innerHeight * 0.5) {
      document.documentElement.style.setProperty('--r8-chrome-h', h + 'px');
    }

    // A product page can also carry a sticky anchor nav under the header.
    // Anything that sticks has to clear both, not just the header.
    var sub = document.querySelector('.r8-anchor-nav-sticky, [class*="anchor-nav-sticky"]');
    var subH = 0;

    if (sub && getComputedStyle(sub).position === 'sticky') {
      subH = Math.round(sub.getBoundingClientRect().height);
    }

    document.documentElement.style.setProperty('--r8-subnav-h', subH + 'px');
  }

  // Die Fragenliste ist laenger als das Fenster, deshalb folgt die Auswahl
  // beim Scrollen der Frage, die der Mitte am naechsten steht. Die Antwort
  // liegt absolut in der zweiten Spalte und beginnt auf der Hoehe ihrer
  // eigenen Frage: dafuer bekommt jede Tafel diesen Abstand mit. Weil die
  // Tafeln keine Rasterzeile aufziehen, aendert ein Wechsel nichts an der
  // Hoehe der Liste - sonst flackert es.
  function faqScrollSpy(root) {
    var grids = (root || document).querySelectorAll('[data-r8-faq]');

    grids.forEach(function (grid) {
      if (grid.dataset.r8FaqReady === 'true') return;
      grid.dataset.r8FaqReady = 'true';

      var breit = window.matchMedia('(min-width: 990px)');
      var items = grid.querySelectorAll('[data-q]');
      if (items.length < 2) return;

      function abstaende() {
        var kasten = grid.getBoundingClientRect();
        grid.querySelectorAll('[data-pane]').forEach(function (pane) {
          var frage = grid.querySelector('[data-q="' + pane.dataset.pane + '"]');
          if (!frage) return;
          if (!breit.matches) { pane.style.removeProperty('--r8-oben'); return; }

          // Die eingeklappten Tafeln stehen auf display:none und messen sich
          // als null. Kurz unsichtbar einblenden, messen, zuruecksetzen.
          var merk = pane.style.display;
          pane.style.visibility = 'hidden';
          pane.style.display = 'block';
          var inhalt = pane.firstElementChild;
          var hoch = inhalt ? inhalt.offsetHeight : 0;
          pane.style.display = merk;
          pane.style.removeProperty('visibility');

          // Die letzte Antwort ist laenger als das, was unter ihrer Frage noch
          // uebrig ist. Sie wandert so weit nach oben, dass sie an der
          // Unterkante des Elements endet statt in den naechsten Abschnitt zu
          // laufen.
          var ziel = Math.round(frage.getBoundingClientRect().top - kasten.top);
          ziel = Math.min(ziel, Math.max(0, Math.round(kasten.height - hoch)));
          pane.style.setProperty('--r8-oben', Math.max(0, ziel) + 'px');
        });
      }

      abstaende();
      window.addEventListener('load', abstaende);
      window.addEventListener('resize', abstaende);

      if (reduced || !('IntersectionObserver' in window)) return;

      var lock = 0;
      // Ein Klick soll kurz gewinnen, sonst springt die Auswahl sofort zurueck
      // auf die Frage, die gerade mittig steht.
      grid.addEventListener('click', function () { lock = Date.now(); });

      var io = new IntersectionObserver(function (entries) {
        if (!breit.matches) return;
        if (Date.now() - lock < 900) return;

        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var n = entry.target.dataset.q;
          // Section-IDs enthalten "--", was in einem CSS-Selektor umstaendlich
          // ist; getElementById nimmt die ID so, wie sie dasteht.
          var radio = document.getElementById(grid.dataset.r8Faq + n);
          if (radio && !radio.checked) radio.checked = true;
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      items.forEach(function (item) { io.observe(item); });
    });
  }

  // Ein zweiter Klick auf dieselbe Zeile klappt sie wieder zu. Die Auswahl
  // laeuft ueber Radios, und ein Radio laesst sich durch Anklicken nicht
  // abwaehlen - deshalb schaltet dieser Griff auf den versteckten
  // "zu"-Radio um. Ohne Skript bleibt alles bedienbar: dann wechselt man
  // einfach zur naechsten Zeile, statt zuzuklappen.
  function zweiterKlickSchliesst(root) {
    var gruppen = (root || document).querySelectorAll('[data-r8-zu]');

    gruppen.forEach(function (gruppe) {
      if (gruppe.dataset.r8ZuReady === 'true') return;
      gruppe.dataset.r8ZuReady = 'true';

      gruppe.addEventListener('click', function (e) {
        var schalter = e.target.closest('label[for]');
        if (!schalter || !gruppe.contains(schalter)) return;

        var feld = document.getElementById(schalter.getAttribute('for'));
        if (!feld || feld.type !== 'radio' || !feld.checked) return;

        var zu = document.getElementById(gruppe.dataset.r8Zu);
        if (!zu) return;

        e.preventDefault();
        zu.checked = true;
      });

      // Die Tafel oeffnet unter allen Kacheln. Auf kleinen Bildschirmen
      // liegt sie dann ausserhalb des Blicks - also dorthin, aber nur wenn
      // sie nicht schon ganz zu sehen ist.
      gruppe.addEventListener('change', function (e) {
        var feld = e.target;
        var zuId = gruppe.dataset.r8Zu;
        if (!feld || feld.type !== 'radio' || !feld.checked || feld.id === zuId) return;

        var nr = feld.id.slice(zuId.length - 2);
        var tafel = gruppe.querySelector('[data-tafel="' + nr + '"]');
        if (!tafel) return;

        requestAnimationFrame(function () {
          var css = getComputedStyle(document.documentElement);
          var kopf = (parseFloat(css.getPropertyValue('--r8-chrome-h')) || 61)
            + (parseFloat(css.getPropertyValue('--r8-subnav-h')) || 0) + 16;
          var r = tafel.getBoundingClientRect();
          if (r.top >= kopf && r.bottom <= window.innerHeight) return;
          window.scrollTo({ top: r.top + window.scrollY - kopf, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Two sections of the same colour stack their full vertical rhythm twice, so
     the seam reads as a gap rather than a join. Where the colour does change,
     the band needs that padding to breathe, and CSS cannot compare the two.
     Marked here instead: equal background, halved seam. */
  /* ---------- Sand und Weiss im Wechsel ----------
     Welche Abschnitte eine Produktseite zeigt, haengt am Produkt: die
     Dosierung laeuft nur beim Essentials Komplex, der Preisvergleich nicht
     beim Zellschutz. Eine feste Farbfolge, die auf allen drei Seiten
     abwechselt, gibt es deshalb nicht - rechnerisch nicht, bei genau diesen
     Ausfaellen. Darum verteilen wir Sand und Weiss hier nach dem, was
     wirklich gerendert ist. Den Takt gibt der erste neutrale Abschnitt vor,
     farbige bleiben, wie sie in den Einstellungen stehen.

     Die Vorlagen sind so gesetzt, dass der Wechsel beim Essentials Komplex
     und auf den Bundles schon von sich aus stimmt - dort aendert diese
     Funktion nichts und es gibt kein Umspringen nach dem Laden. */
  var R8_NEUTRAL = {
    'rgb(255, 255, 255)': 'weiss',
    'rgb(247, 245, 241)': 'sand'
  };

  function takt() {
    var naechste = null;

    [].forEach.call(document.querySelectorAll('.r8v2-section'), function (el) {
      var inner = el.querySelector('.r8-section');
      if (!inner) return;

      // Erst die eigene Farbe freilegen, sonst lesen wir unsere eigene.
      inner.removeAttribute('data-r8-takt');
      var eigen = R8_NEUTRAL[getComputedStyle(inner).backgroundColor];
      if (!eigen) return;

      if (!naechste) naechste = eigen;
      if (naechste !== eigen) inner.setAttribute('data-r8-takt', naechste);
      naechste = naechste === 'sand' ? 'weiss' : 'sand';
    });
  }

  function seams() {
    var sections = [].slice.call(document.querySelectorAll('.r8v2-section'));
    var prevBg = null;

    sections.forEach(function (el) {
      // a section that renders nothing (a block gated to another
      // product, say) takes no height, so it is not a break in the colour run.
      var inner = el.querySelector('.r8-section');
      if (!inner) return;

      var bg = getComputedStyle(inner).backgroundColor;
      inner.classList.toggle('r8-section--seam', bg === prevBg);
      prevBg = bg;
    });
  }

  /* A tile opening in place shoves its row taller and leaves the others
     standing in empty space. Instead the open one takes a 2 x 2 field and the
     rest flow around it — measured before and after, then played back as a
     transform so the move reads as motion rather than a jump. */
  function specGrids(root) {
    var grids = (root || document).querySelectorAll('.r8-specs__list');

    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.r8Specs) return;
      grid.dataset.r8Specs = '1';

      var tiles = [].slice.call(grid.querySelectorAll('details.r8-spec'));
      if (!tiles.length) return;

      grid.addEventListener('click', function (e) {
        var head = e.target && e.target.closest ? e.target.closest('.r8-spec__head') : null;
        if (!head || !grid.contains(head)) return;

        var tile = head.parentElement;
        e.preventDefault();

        var before = tiles.map(function (t) { return t.getBoundingClientRect(); });
        var opening = !tile.open;
        tiles.forEach(function (t) { t.open = opening && t === tile; });

        if (reduced) return;

        var after = tiles.map(function (t) { return t.getBoundingClientRect(); });
        tiles.forEach(function (t, i) {
          var dx = before[i].left - after[i].left;
          var dy = before[i].top - after[i].top;
          if (!dx && !dy) return;

          t.style.transition = 'none';
          t.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
        });

        requestAnimationFrame(function () {
          tiles.forEach(function (t) {
            if (!t.style.transform) return;
            t.style.transition = 'transform 420ms var(--r8-ease)';
            t.style.transform = '';
          });
        });
      });
    });
  }

  // Der Vergleich steht am Telefon als eine Spalte. Ohne Schalter stuenden
  // beide Seiten untereinander — lesbar, aber doppelt so lang. Der Schalter
  // zeigt eine Seite und traegt dafuer die Beschriftung. Er wird erst hier
  // eingeblendet, damit die Sektion ohne JavaScript nichts Totes zeigt.
  function vergleichUmschalter(root) {
    var wahlen = (root || document).querySelectorAll('[data-r8-cmp-wahl]');

    wahlen.forEach(function (wahl) {
      if (wahl.dataset.r8CmpReady === 'true') return;
      wahl.dataset.r8CmpReady = 'true';

      var tafel = wahl.parentNode.querySelector('[data-r8-cmp-tafel]');
      if (!tafel) return;

      wahl.hidden = false;

      wahl.addEventListener('click', function (e) {
        var knopf = e.target.closest('button[data-seite]');
        if (!knopf) return;
        var seite = knopf.dataset.seite;
        tafel.setAttribute('data-seite', seite);
        wahl.querySelectorAll('button[data-seite]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === knopf ? 'true' : 'false');
        });
      });
    });
  }

  // Lange Elemente am Telefon kuerzen. Generisch: jeder Wrapper mit
  // [data-r8-mehr] und einem Kind .r8-mehr__inhalt bekommt die Mechanik, der
  // Wert ist die Resthoehe in px. Der Knopf entsteht erst, wenn tatsaechlich
  // etwas abgeschnitten wird — sonst stuende dort ein Knopf ohne Funktion.
  var SCHMAL = '(max-width: 749px)';

  function mehrLaden(root) {
    var bloecke = (root || document).querySelectorAll('[data-r8-mehr]');
    if (!bloecke.length) return;

    bloecke.forEach(function (block) {
      var inhalt = block.querySelector('.r8-mehr__inhalt');
      if (!inhalt) return;

      var hoehe = parseInt(block.getAttribute('data-r8-mehr'), 10) || 520;
      block.style.setProperty('--r8-mehr-hoehe', hoehe + 'px');

      var knopf = block.querySelector('.r8-mehr__knopf');
      if (!knopf) {
        knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'r8-mehr__knopf';
        knopf.addEventListener('click', function () {
          var zu = block.classList.toggle('is-zu');
          // Vom Nutzer geoeffnet bleibt geoeffnet: sonst klappte es die
          // naechste Hoehenmessung wieder zu.
          if (zu) {
            block.removeAttribute('data-r8-mehr-offen');
            block.scrollIntoView({ block: 'nearest' });
          } else {
            block.setAttribute('data-r8-mehr-offen', '');
          }
          knopf.textContent = zu ? auf_text(block) : zu_text(block);
          knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
        });
        block.appendChild(knopf);
      }

      function pruefe() {
        if (!window.matchMedia(SCHMAL).matches) {
          block.classList.remove('is-zu', 'has-knopf');
          return;
        }
        // scrollHeight ist die volle Inhaltshoehe, auch wenn max-height
        // gerade deckelt — es braucht kein Auf- und Zuklappen zum Messen.
        // Unter 120px Ueberhang lohnt der Knopf nicht: man scrollt weniger,
        // als der Knopf selbst an Hoehe kostet.
        var lohnt = inhalt.scrollHeight > hoehe + 120;
        block.classList.toggle('has-knopf', lohnt);
        var zu = lohnt && !block.hasAttribute('data-r8-mehr-offen');
        block.classList.toggle('is-zu', zu);
        knopf.textContent = zu ? auf_text(block) : zu_text(block);
        knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
      }

      if (!block.hasAttribute('data-r8-mehr-fertig')) {
        block.setAttribute('data-r8-mehr-fertig', '');
        window.matchMedia(SCHMAL).addEventListener('change', pruefe);
        // Tabs und Aufklapper aendern die Hoehe im laufenden Betrieb.
        block.addEventListener('change', function () { window.requestAnimationFrame(pruefe); });
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () { window.requestAnimationFrame(pruefe); });
          ro.observe(inhalt);
        }
      }

      pruefe();
    });
  }

  function auf_text(block) {
    return block.getAttribute('data-r8-mehr-auf') || 'Alles anzeigen';
  }

  function zu_text(block) {
    return block.getAttribute('data-r8-mehr-zu') || 'Weniger anzeigen';
  }

  // Punkte unter einer Wischspur: [data-r8-wisch] ist die Spur, das
  // Geschwister [data-r8-wisch-punkte] die Leiste. Ein Punkt je Halt, der
  // aktive folgt dem Scrollstand. Nur am Telefon und nur bei Ueberlauf.
  // Halte: Standard = jedes sichtbare Kind (Karten, Galeriebilder).
  // data-r8-wisch="seiten" = je Fensterbreite ein Halt, fuer lange Reihen
  // (30 Zutatenbilder haetten sonst 30 Punkte).
  function wischPunkte(root) {
    var spuren = (root || document).querySelectorAll('[data-r8-wisch]');
    if (!spuren.length) return;

    spuren.forEach(function (spur) {
      var leiste = spur.parentNode.querySelector('[data-r8-wisch-punkte]');
      if (!leiste) return;

      var seitenweise = spur.getAttribute('data-r8-wisch') === 'seiten';
      var halte = [];

      function messen() {
        var max = spur.scrollWidth - spur.clientWidth;
        halte = [];
        if (seitenweise) {
          var breite = spur.clientWidth;
          if (breite <= 0) return;
          for (var x = 0; x < max; x += breite) halte.push(x);
          halte.push(max);
        } else {
          [].slice.call(spur.children).forEach(function (karte) {
            // Ausgeblendete Kinder (z. B. Variantenbilder der Galerie) zaehlen nicht.
            if (karte.offsetWidth > 0) halte.push(Math.min(max, karte.offsetLeft - spur.clientLeft));
          });
        }
      }

      function naechste() {
        // Der Halt, der dem Scrollstand am naechsten liegt - der, auf den
        // gerade geschnappt wurde.
        var beste = 0;
        var kleinster = Infinity;
        halte.forEach(function (x, i) {
          var abstand = Math.abs(x - spur.scrollLeft);
          if (abstand < kleinster) {
            kleinster = abstand;
            beste = i;
          }
        });
        return beste;
      }

      function markiere() {
        var an = naechste();
        [].slice.call(leiste.children).forEach(function (punkt, i) {
          punkt.classList.toggle('is-an', i === an);
          punkt.setAttribute('aria-current', i === an ? 'true' : 'false');
        });
      }

      function baue() {
        messen();
        var wischbar = window.matchMedia(SCHMAL).matches && spur.scrollWidth > spur.clientWidth + 1;
        leiste.classList.toggle('is-an', wischbar && halte.length > 1);
        if (leiste.children.length === halte.length) {
          if (wischbar) markiere();
          return;
        }
        leiste.textContent = '';
        halte.forEach(function (x, i) {
          var punkt = document.createElement('button');
          punkt.type = 'button';
          punkt.className = 'r8-wisch__punkt';
          punkt.setAttribute('aria-label', (seitenweise ? 'Zu Abschnitt ' : 'Zu Bild ') + (i + 1) + ' von ' + halte.length);
          punkt.addEventListener('click', function () {
            // scrollLeft statt scrollIntoView: letzteres zieht auch die
            // Seite senkrecht mit, die Karte steht aber schon im Blick.
            spur.scrollTo({ left: halte[i], behavior: 'smooth' });
          });
          leiste.appendChild(punkt);
        });
        markiere();
      }

      if (!spur.hasAttribute('data-r8-wisch-fertig')) {
        spur.setAttribute('data-r8-wisch-fertig', '');
        var wartet = false;
        spur.addEventListener(
          'scroll',
          function () {
            if (wartet) return;
            wartet = true;
            window.requestAnimationFrame(function () {
              wartet = false;
              markiere();
            });
          },
          { passive: true }
        );
        window.matchMedia(SCHMAL).addEventListener('change', baue);
        if ('ResizeObserver' in window) {
          new ResizeObserver(function () { window.requestAnimationFrame(baue); }).observe(spur);
        }
      }

      baue();
    });
  }

  /* ---------- Zwei-Finger-Zoom in der Produkt-Lightbox ----------
     Am Telefon passt das Bild zuerst in den Bildschirm (CSS in
     r8v2-product.css). Zwei Finger skalieren die Bildbreite in px, der
     Container scrollt nativ - deshalb Touch-Events statt Pointer-Events:
     ein Finger bleibt Browser-Scroll, nur bei zwei Fingern uebernehmen wir.
     Doppeltipp wechselt zwischen 1x und 2,5x. Schliessen setzt zurueck. */
  function lightboxZoom() {
    var MAX = 4;

    function abstand(t) {
      return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    }

    function setze(img, box, breite, fixX, fixY, alt) {
      // fixX/fixY: Punkt im Fenster, der unter den Fingern bleiben soll.
      var r = box.getBoundingClientRect();
      var relX = (fixX - r.left + box.scrollLeft) / alt;
      var relY = (fixY - r.top + box.scrollTop) / alt;
      var basis = img.getAttribute('data-r8-basis') | 0;
      var skala = breite / basis;
      if (skala <= 1.01) {
        img.classList.remove('r8-zoom');
        img.style.width = '';
        return;
      }
      img.classList.add('r8-zoom');
      img.style.width = breite + 'px';
      box.scrollLeft = relX * breite - (fixX - r.left);
      box.scrollTop = relY * breite - (fixY - r.top);
    }

    function aktuell(img) {
      return img.classList.contains('r8-zoom') ? img.getBoundingClientRect().width : (img.getAttribute('data-r8-basis') | 0);
    }

    document.addEventListener('touchstart', function (e) {
      var img = e.target.closest('.product-media-modal__content > img');
      if (!img || !window.matchMedia(SCHMAL).matches) return;
      var box = img.parentNode;
      if (!img.classList.contains('r8-zoom')) img.setAttribute('data-r8-basis', Math.round(img.getBoundingClientRect().width));

      if (e.touches.length === 2) {
        img._r8d0 = abstand(e.touches);
        img._r8b0 = aktuell(img);
        return;
      }
      // Doppeltipp
      var jetzt = Date.now();
      if (img._r8tipp && jetzt - img._r8tipp < 300) {
        var basis = img.getAttribute('data-r8-basis') | 0;
        var ziel = img.classList.contains('r8-zoom') ? basis : basis * 2.5;
        setze(img, box, ziel, e.touches[0].clientX, e.touches[0].clientY, aktuell(img));
        img._r8tipp = 0;
        e.preventDefault();
      } else {
        img._r8tipp = jetzt;
      }
    }, { passive: false });

    document.addEventListener('touchmove', function (e) {
      var img = e.target.closest('.product-media-modal__content > img');
      if (!img || e.touches.length !== 2 || !img._r8d0) return;
      e.preventDefault();
      var basis = img.getAttribute('data-r8-basis') | 0;
      var neu = Math.min(basis * MAX, Math.max(basis, img._r8b0 * abstand(e.touches) / img._r8d0));
      var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      setze(img, img.parentNode, neu, mx, my, aktuell(img));
    }, { passive: false });

    document.addEventListener('touchend', function (e) {
      var img = e.target.closest && e.target.closest('.product-media-modal__content > img');
      if (img && e.touches.length < 2) img._r8d0 = 0;
    });

    document.body.addEventListener('modalClosed', function () {
      document.querySelectorAll('.product-media-modal__content > img.r8-zoom').forEach(function (img) {
        img.classList.remove('r8-zoom');
        img.style.width = '';
      });
    });
  }

  /* ---------- Verweise ohne sichtbares Ziel ----------
     Die Produktnavigation und der Hinweis in der Naehrwerttabelle zeigen auf
     Abschnitte derselben Seite. Nicht jede Seite traegt jeden Abschnitt: beim
     Longevity und Zellschutz Komplex fehlt die Dosierung, und die
     Wirkstoff-Matrix auf der Wissenschaftsseite blendet sich am Telefon
     selbst aus. Ein Verweis auf ein fehlendes oder unsichtbares Ziel springt
     nirgendwohin - der Klick sah aus, als sei die Seite kaputt.

     Versteckt statt geloescht, damit ein Wechsel der Fensterbreite den
     Eintrag zurueckholen kann. */
  function toteAnker() {
    var links = document.querySelectorAll(
      '[data-r8-anchor-list] a[href^="#"], .r8-nut__info-link, .r8-nt__info-link'
    );
    [].forEach.call(links, function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      var ziel = id ? document.getElementById(id) : null;
      /* Nicht jedes Ziel traegt selbst Hoehe: manche Anker sind leere Marken
         innerhalb eines Abschnitts. Gemessen wird deshalb der Abschnitt, in
         dem die Marke sitzt - der ist bei display:none ebenfalls null. */
      var sichtbar = false;
      if (ziel) {
        var kasten = ziel.closest('[id^="shopify-section-"]') || ziel;
        sichtbar =
          (ziel.offsetParent !== null || ziel.getClientRects().length > 0) &&
          kasten.getBoundingClientRect().height > 1;
      }
      var traeger = a.closest('li') || a;
      traeger.hidden = !sichtbar;
    });
  }

  var toteAnkerWartet;
  window.addEventListener('resize', function () {
    clearTimeout(toteAnkerWartet);
    toteAnkerWartet = setTimeout(toteAnker, 200);
  });

  /* ---------- Zweiter Kaufmoment ----------
     Der Knopf unter dem Preisvergleich klickt den Kaufknopf des Abo-Waehlers
     oben auf der Seite: ein Kaufmechanismus, kein Nachbau der Warenkorb-
     Logik. Die Zeile darunter spiegelt die gewaehlte Option, "Auswahl
     aendern" scrollt zum Waehler. Ohne Waehler auf der Seite fuehrt der
     Knopf zum hinterlegten Link. */
  function zweiterKauf(root) {
    var bloecke = (root || document).querySelectorAll('[data-r8-zweitkauf]');
    if (!bloecke.length) return;
    var waehler = document.querySelector('r8-subscription-picker');
    var absenden = waehler && waehler.querySelector('.product-form__submit');

    function gewaehlt() {
      if (!waehler) return '';
      var radio = waehler.querySelector('.r8-radio:checked');
      var karte = radio && radio.closest('.r8-card');
      if (!karte) return '';
      var titel = karte.querySelector('.r8-title');
      var name = titel ? (titel.childNodes[0] ? titel.childNodes[0].textContent : titel.textContent).trim() : '';
      var betrag = karte.querySelector('.r8-amount');
      var je = karte.querySelector('.r8-per');
      var teile = [name];
      if (betrag) teile.push((betrag.textContent.trim() + ' ' + (je ? je.textContent.trim() : '')).trim());
      return teile.filter(Boolean).join(' \u00b7 ');
    }

    /* Der gewaehlte Plan aus dem Waehler selbst: Preis je 30 Tage in Cent.
       Der Waehler haelt seine Optionen als Eigenschaft, das ist genauer als
       formatierten Text zurueckzulesen. */
    function gewaehlterPlan() {
      if (!waehler || !waehler.choices || !waehler.money) return null;
      var plan = waehler.choices.find(function (c) { return c.id === waehler.selectedId; });
      if (!plan || !plan.total) return null;
      return { je30: plan.months ? plan.total / plan.months : plan.total, abo: !!plan.months };
    }

    function spiegeln() {
      var text = gewaehlt();
      var plan = gewaehlterPlan();
      [].forEach.call(bloecke, function (b) {
        var zeile = b.querySelector('[data-r8-zweitkauf-wahl]');
        var aendern = b.querySelector('[data-r8-zweitkauf-aendern]');
        if (zeile) { zeile.textContent = text; zeile.hidden = !text; }
        if (aendern) aendern.hidden = !text;

        /* Die grosse Zahl der Karte und die Ersparnis folgen der Wahl: im Abo
           steht der Abo-Preis je 30 Tage, und gespart wird gegen ihn. Die
           Summe der Einzelpraeparate liefert Liquid als Daten an der Karte. */
        var karte = b.closest('[data-r8-karte]');
        if (!karte || !plan) return;
        var preis = karte.querySelector('[data-r8-karte-preis]');
        var sparen = karte.querySelector('[data-r8-karte-sparen]');
        var summe = parseInt(karte.getAttribute('data-r8-summe'), 10) || 0;
        if (preis) {
          // Das Intervall als Randnotiz, nicht als Teil der grossen Zahl.
          preis.textContent = waehler.money(plan.je30);
          if (plan.abo) {
            var je = document.createElement('span');
            je.className = 'r8-karte-je';
            je.textContent = '/ 30 Tage';
            preis.append(' ', je);
          }
        }
        if (sparen) {
          var diff = summe - plan.je30;
          sparen.hidden = !(summe > 0 && diff > 0);
          if (!sparen.hidden) sparen.textContent = (karte.getAttribute('data-r8-sparen-praefix') || 'Du sparst') + ' ' + waehler.money(diff);
        }
      });
    }

    [].forEach.call(bloecke, function (b) {
      var knopf = b.querySelector('.r8-zweitkauf__knopf');
      var aendern = b.querySelector('[data-r8-zweitkauf-aendern]');
      if (knopf) knopf.addEventListener('click', function () {
        if (absenden && !absenden.disabled) { absenden.click(); return; }
        if (waehler) { zumWaehler(); return; }
        var ziel = b.getAttribute('data-ziel');
        if (ziel && ziel !== '#') window.location.href = ziel;
      });
      if (aendern) aendern.addEventListener('click', zumWaehler);
    });

    function zumWaehler() {
      if (!waehler) return;
      var kasten = waehler.querySelector('.r8-options') || waehler;
      var oben = kasten.getBoundingClientRect().top + window.scrollY
        - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--r8-chrome-h')) || 61)
        - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--r8-subnav-h')) || 0) - 24;
      window.scrollTo({ top: oben, behavior: 'smooth' });
      kasten.classList.remove('r8-blitz');
      void kasten.offsetWidth;
      kasten.classList.add('r8-blitz');
    }

    if (waehler) {
      waehler.addEventListener('change', spiegeln);
      // Der Waehler baut seine Karten bei Variantenwechsel neu auf.
      new MutationObserver(spiegeln).observe(waehler, { childList: true, subtree: true });
    }
    spiegeln();
  }

  /* Das Reviews.io-Karussell schreibt seinen Durchschnitt als "5 Bewertung"
     in den Kopf - eine schiefe Uebersetzung von "5 rating", die neben
     "14 Bewertungen" wie eine zweite Anzahl aussieht. Das Widget rendert
     erst nach dem Laden, deshalb wartet ein Beobachter auf den Kopf und
     schreibt die Zeile einmal um. */
  function bewertungsKopf() {
    if (window.__r8BewKopf) return;
    window.__r8BewKopf = true;
    function fix() {
      var zeilen = document.querySelectorAll('.cssVar-header__subheading');
      [].forEach.call(zeilen, function (z) {
        if (z.dataset.r8Fix) return;
        var t = z.textContent.replace(/\s+/g, ' ').trim();
        var m = t.match(/^(\d+(?:[.,]\d+)?) Bewertung$/);
        if (!m) return;
        var wert = parseFloat(m[1].replace(',', '.'));
        z.dataset.r8Fix = '1';
        z.textContent = wert.toFixed(1).replace('.', ',') + ' von 5 Sternen';
      });
    }
    fix();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(fix);
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
  }

  function init(root) {
    takt();
    seams();
    specGrids(root);
    revealIn(root);
    phasesIn(root);
    faqScrollSpy(root);
    zweiterKlickSchliesst(root);
    vergleichUmschalter(root);
    mehrLaden(root);
    wischPunkte(root);
    if (!document.documentElement.hasAttribute('data-r8-lightbox')) {
      document.documentElement.setAttribute('data-r8-lightbox', '');
      lightboxZoom();
    }
    toteAnker();
    zweiterKauf(root);
    bewertungsKopf();
    chromeHeight();

    if (!window.__r8ChromeWatch && 'ResizeObserver' in window) {
      var header = document.querySelector('.header-wrapper, sticky-header');
      if (header) {
        window.__r8ChromeWatch = new ResizeObserver(chromeHeight);
        window.__r8ChromeWatch.observe(header);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


/* ---------- Bewertungs-Widget auf Deutsch ----------
   Das Widget des Bewertungsdienstes liefert "5 Rating" und zaehlt im Plural,
   auch bei einer einzigen Stimme. Beides laesst sich dort nicht einstellen,
   also wird der Text nach dem Rendern korrigiert — nur Text, keine Zahlen. */
(function () {
  var MUSTER = [
    [/(\d+(?:[.,]\d+)?)\s*Rating\b/g, '$1 von 5'],
    [/\b1 Bewertungen\b/g, '1 Bewertung'],
    [/\(1 Bewertungen\)/g, '(1 Bewertung)'],
    [/\bRating\b/g, 'Bewertung'],
    [/\bReviews\b/g, 'Bewertungen'],
    [/\bReview\b/g, 'Bewertung'],
  ];

  function korrigiere(wurzel) {
    if (!wurzel) return;
    /* Ohne Filter liefe der Walker auch durch <style> und <script>: dort
       stehen Klassennamen wie "R-Rating" und Bezeichner, die beim Ersetzen
       kaputtgingen. */
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (knoten) {
        var eltern = knoten.parentNode;
        if (!eltern) return NodeFilter.FILTER_REJECT;
        var tag = eltern.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var knoten;
    while ((knoten = lauf.nextNode())) {
      var vorher = knoten.nodeValue;
      var nachher = vorher;
      for (var i = 0; i < MUSTER.length; i++) {
        nachher = nachher.replace(MUSTER[i][0], MUSTER[i][1]);
      }
      if (nachher !== vorher) knoten.nodeValue = nachher;
    }
  }

  function start() {
    korrigiere(document.body);
    var beobachter = new MutationObserver(function (eintraege) {
      eintraege.forEach(function (eintrag) {
        eintrag.addedNodes.forEach(function (knoten) {
          if (knoten.nodeType === 1) korrigiere(knoten);
          else if (knoten.nodeType === 3) korrigiere(knoten.parentNode);
        });
      });
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ---------- Scroll-Kante der Kopfleiste ----------
   Oben an der Seite traegt die Leiste keine Linie, sobald Inhalt unter ihr
   weglaeuft schon. Ein Schwellwert von 8px verhindert Flackern. */
(function () {
  var koerper = document.body;
  var gesetzt = false;
  var wartet = false;

  function pruefe() {
    wartet = false;
    var soll = window.scrollY > 8;
    if (soll !== gesetzt) {
      gesetzt = soll;
      koerper.classList.toggle('r8-gescrollt', soll);
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(pruefe);
    },
    { passive: true }
  );

  pruefe();
})();
